module.exports = __webpack_public_path__ + "img/TechArchAttack3_ua.37c541e5.webp";